export default __webpack_public_path__ + "static/media/concize_logo_white.e941b00f.png";